import { useState } from "react";
import { TreePine } from "lucide-react";
import { cn } from "@/lib/utils";

interface BlurredImageContainerProps {
  src: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
  priority?: boolean;
}

export function BlurredImageContainer({ src, alt, className, fallback, priority }: BlurredImageContainerProps) {
  const loading = priority ? "eager" : "lazy";
  const fetchPriority = priority ? "high" : "auto";
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className={cn("relative flex items-center justify-center overflow-hidden bg-secondary", className)}
        style={{ aspectRatio: "4/3" }}
        role="img"
        aria-label={alt}
      >
        {fallback ?? <TreePine className="h-10 w-10 text-muted-foreground/60" aria-hidden />}
      </div>
    );
  }

  return (
    <div className={cn("relative overflow-hidden bg-secondary", className)} style={{ aspectRatio: "4/3" }}>
      {/* Blurred backdrop */}
      <img
        src={src}
        alt=""
        aria-hidden
        loading={loading}
        decoding="async"
        // @ts-expect-error fetchpriority is a valid HTML attribute
        fetchpriority={fetchPriority}
        onError={() => setErrored(true)}
        className="absolute inset-0 h-full w-full object-cover blur-[14px] scale-110 brightness-[0.6]"
      />
      {/* Sharp foreground */}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        // @ts-expect-error fetchpriority is a valid HTML attribute
        fetchpriority={fetchPriority}
        onError={() => setErrored(true)}
        className="relative z-10 h-full w-full object-contain"
      />
    </div>
  );
}
